import { useEffect, useRef } from "react";

interface Props {
  url: string;
  size?: number;
}

/**
 * Renders a QR code using the free QR Server API — no npm package needed.
 * Falls back to a placeholder if URL is empty.
 */
export default function QRCodeDisplay({ url, size = 200 }: Props) {
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    if (imgRef.current && url) {
      imgRef.current.src = `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(url)}&format=png&margin=10`;
    }
  }, [url, size]);

  if (!url) {
    return (
      <div
        className="flex items-center justify-center rounded-xl border border-dashed border-slate-200 bg-slate-50 text-slate-300"
        style={{ width: size, height: size }}
      >
        <i className="ri-qr-code-line text-4xl"></i>
      </div>
    );
  }

  return (
    <div className="inline-block rounded-xl overflow-hidden border border-slate-200 bg-white p-2">
      <img
        ref={imgRef}
        alt="QR Code"
        width={size}
        height={size}
        className="block rounded-lg"
        style={{ imageRendering: "pixelated" }}
      />
    </div>
  );
}